import { ChangeEventHandler, useRef } from "react";
// import { getInitials } from "../../../src/Custom hooks/helpers";
import styles from "./style.module.css";
import { getInitials } from "../../../hooks/helpers";
import { ReactComponent as AddIconSvg } from "../../../../../assets/addIcon.svg";
import { resolveImageSrc } from "../../../../../utils/ConvertImage";

interface Props {
  edit?: boolean;
  src?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  btnText: string;
  fallback?: string;
  accept?: string;
}

const UploadImageTemp = ({
  edit,
  src,
  onChange,
  btnText,
  fallback,
  accept,
}: Props) => {
  const imageRef = useRef<HTMLInputElement>(null);
  return (
    <div
      className={styles.container}
      onClick={() => imageRef.current && imageRef.current.click()}
    >
      <div className={styles.imageContainer}>
        {!src ? (
          <div className={styles.placeholder}>
            {/* {!fallback ? (
              <p onClick={() => imageRef.current && imageRef.current.click()}>
                Upload image
              </p>
            ) : (
              <h1>{getInitials({ username: fallback })}</h1>
            )} */}
            <div className={styles.inner}>
              <AddIconSvg
              // onClick={() => imageRef.current && imageRef.current.click()}
              />
              <p>Upload image</p>
              <div className={styles.resolution}>500 x 500 (px)</div>
            </div>
          </div>
        ) : (
          <img src={resolveImageSrc(src)} alt={""} />
        )}
      </div>
      {!edit && (
        <>
          <input
            hidden
            ref={imageRef}
            type="file"
            accept={accept ? accept : "image/jpeg"}
            onChange={onChange}
          />
          {/* TODO accept only jpeg file. Should convert or warn? */}
          {/* <button
            type="button"
            onClick={() => imageRef.current && imageRef.current.click()}
          >
            {btnText}
          </button> */}
        </>
      )}
    </div>
  );
};

export default UploadImageTemp;
